import { render, staticRenderFns } from "./crewNewsDetail.vue?vue&type=template&id=ee98903c&scoped=true"
import script from "./crewNewsDetail.vue?vue&type=script&lang=js"
export * from "./crewNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee98903c",
  null
  
)

export default component.exports